import type { ReactNode } from 'react';
import { useAuth } from '@/context/AuthContext';
import { useTranslation } from '@/context/LanguageContext';

export function PurchasePriceRoute({ children, fallback, documentRead = false }: { children: ReactNode; fallback?: ReactNode; documentRead?: boolean }) {
  const { user } = useAuth();
  const { lang } = useTranslation();
  if (user?.can_view_purchase_prices === true || (documentRead && user?.can_view_branch_purchases === true)) return <>{children}</>;
  return (
    <>
      {fallback ?? (
        <p className="p-6 text-muted-foreground" role="status">
          {lang === 'UZ'
            ? 'Xarid narxlari uchun alohida ruxsat kerak.'
            : 'Для просмотра закупочных цен требуется отдельное право.'}
        </p>
      )}
    </>
  );
}
